import { render, staticRenderFns } from "./EventApply.vue?vue&type=template&id=15e634a4&scoped=true"
import script from "./EventApply.vue?vue&type=script&lang=js"
export * from "./EventApply.vue?vue&type=script&lang=js"
import style0 from "./EventApply.vue?vue&type=style&index=0&id=15e634a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e634a4",
  null
  
)

export default component.exports